import React from "react";

export default ({ video, autoplay = "1", rel = "0", modest = "1", className = '' }) => {
    const videoSrc = "https://www.youtube.com/embed/" +
        video + "?autoplay=" +
        autoplay + "&rel=" +
        rel + "&modestbranding=" +
        modest;

    return (
        <div className="m-youtube">
            <div className={ "m-youtube__wrapper" + className }>
                <iframe className="m-youtube__video"
                        type="text/html"
                        width="100%"
                        height="100%"
                        src={ videoSrc }
                        frameBorder="0"
                />
            </div>
        </div>
    )
}